import faker from 'faker';

const getRandomElementFromArray = (array) => {
  return array[faker.datatype.number(array.length -1)];
}

export default getRandomElementFromArray;
